module.exports = __webpack_public_path__ + "img/hp-case-fire.7c5d6673.png";